import styled from "styled-components"
import { Waypoint } from 'ggx-componentlibrary/components/waypoint/waypoint.component'
import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"

const AlignItemsCenter = styled.div`
    display: inline-flex;
    align-items: center;
    gap: ${SPACING.XS};
    
`

const ClearRemoveButton = styled.button`
  position: relative;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  display: flex;
}
`

const VerticalCenterAlign = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.XS};
  line-height: ${SPACING.M};
  height: ${SPACING.M};
`

const StyledWaypoint = styled(Waypoint)`
  ${ClearRemoveButton} {
    display: none;
  }
  &:hover ${ClearRemoveButton} {
    display: block;
  }
`

export {
  AlignItemsCenter,
  ClearRemoveButton,
  VerticalCenterAlign,
  StyledWaypoint,
}
